import { render, staticRenderFns } from "./ModalWindowComponent.vue?vue&type=template&id=78db1b8e&scoped=true&"
import script from "./ModalWindowComponent.vue?vue&type=script&lang=js&"
export * from "./ModalWindowComponent.vue?vue&type=script&lang=js&"
import style0 from "./ModalWindowComponent.vue?vue&type=style&index=0&id=78db1b8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78db1b8e",
  null
  
)

export default component.exports